import React from 'react';
import '../styles/Home.css';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className='heroic'>
      <div className='heroic-part'>
        <h1 className='heading-one'>
        CodeIgnite
      </h1>
      <h3 className='heading-two'>
        30th October 2025 - 1st November 2025
      </h3>
      <Link to='https://forms.gle/dbm2BiLQxEa6mGfx7' className='register-btn gradient-border'>Register Now</Link>
      </div>
      
    </div>
  )
}

export default Home;